/**
 * Rarest Watches — product gallery + quantity stepper.
 * One slide visible; prev/next, thumbs, 1/N counter, optional keyboard.
 */
(function () {
  'use strict';

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isFinite(n) ? n : fallback;
  }

  function initGallery(root) {
    if (root.getAttribute('data-gallery-ready') === '1') return;
    root.setAttribute('data-gallery-ready', '1');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    if (!slides.length) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var counter = root.querySelector('[data-gallery-counter]');
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    var stage = root.querySelector('[data-gallery-stage]');
    var total = slides.length;
    var index = 0;

    slides.forEach(function (slide, i) {
      if (slide.classList.contains('is-active')) index = i;
    });

    function go(next) {
      if (total < 1) return;
      index = ((next % total) + total) % total;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('hidden');
        else slide.setAttribute('hidden', '');
      });
      thumbs.forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (counter) counter.textContent = index + 1 + ' / ' + total;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { go(index - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { go(index + 1); });
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { go(i); });
    });

    var keyTarget = stage || root;
    keyTarget.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(index + 1);
      }
    });

    var startX = null;
    root.addEventListener('touchstart', function (e) {
      if (!e.changedTouches || !e.changedTouches[0]) return;
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX == null || !e.changedTouches || !e.changedTouches[0]) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      go(dx > 0 ? index - 1 : index + 1);
    }, { passive: true });

    go(index);
  }

  function initQuantity(root) {
    if (root.getAttribute('data-quantity-ready') === '1') return;
    root.setAttribute('data-quantity-ready', '1');
    var input = root.querySelector('.quantity__input');
    if (!input) return;
    var minus = root.querySelector('[data-quantity-minus]');
    var plus = root.querySelector('[data-quantity-plus]');

    function clamp() {
      var min = toInt(input.getAttribute('min'), 1);
      var max = toInt(input.getAttribute('max'), Infinity);
      var value = toInt(input.value, min);
      if (value < min) value = min;
      if (value > max) value = max;
      input.value = String(value);
      return value;
    }

    function step(delta) {
      var next = clamp() + delta;
      input.value = String(next);
      clamp();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    input.addEventListener('change', clamp);
  }

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-quantity]').forEach(initQuantity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
